import { PropsWithChildren, createContext, useContext } from 'react';
import {
  useProductDetailsEmptyAvailabilitiesByOrderIds,
  useProductDetailsSizesByOrderIds,
} from '../../../../services/modules/productDetails/productDetails.queries';
import { ProductDetailsSize } from '../../../../services/modules/productDetails/productDetails.types';
import { GetProductDetailsEmptyAvailabilitiesOutput } from '../types/productDetails.types';

interface ProductDetailsOrderDataValue {
  getSizes: (orderId?: string) => ProductDetailsSize[] | undefined;
  getEmptyAvailabilities: (
    orderId?: string,
  ) => GetProductDetailsEmptyAvailabilitiesOutput[] | undefined;
}

const ProductDetailsOrderDataContext = createContext<ProductDetailsOrderDataValue>({
  getSizes: () => undefined,
  getEmptyAvailabilities: () => undefined,
});

interface ProductDetailsOrderDataProviderProps {
  productId: string;
  orderIds: (string | undefined)[];
}

export const ProductDetailsOrderDataProvider = ({
  productId,
  orderIds,
  children,
}: PropsWithChildren<ProductDetailsOrderDataProviderProps>) => {
  const sizesByOrder = useProductDetailsSizesByOrderIds({ productId, orderIds });
  const emptyAvailabilitiesByOrder = useProductDetailsEmptyAvailabilitiesByOrderIds({
    productId,
    orderIds,
  });

  const value = {
    getSizes: (orderId?: string) => sizesByOrder[orderIds.indexOf(orderId)] ?? undefined,
    getEmptyAvailabilities: (orderId?: string) =>
      emptyAvailabilitiesByOrder[orderIds.indexOf(orderId)] ?? undefined,
  };

  return (
    <ProductDetailsOrderDataContext.Provider value={value}>
      {children}
    </ProductDetailsOrderDataContext.Provider>
  );
};

export const useProductDetailsOrderData = () => useContext(ProductDetailsOrderDataContext);
